import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceImportService } from "./service";

type InsuranceImport = insuranceImportApiSpec.InsuranceImport;

export const createInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.post<InsuranceImport>(``);

  return data;
};
